import React from 'react';

export default class RefreshDataSpinner extends React.Component{
    render(){
        {
            return this.props.loading ?
                <div  className='-loading -active'>
                    <div className="-loading-inner">
                        <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        <span className="sr-only">Loading...</span>
                    </div>
                </div> : null;
            }
        }
}